import React, { createContext, useState } from "react";
import constants from '../utils/constants.js'

const AppContext = createContext([{}, () => {}]);

const AppContextProvider = ({ children }) => {
  const [appState, setAppState] = useState(constants.initialAppState);

  return (
    <AppContext.Provider value={[appState, setAppState]}>
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppContextProvider };
